(function(){
    'use strict';

    angular.module('dataHandlingConditionIsInList', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble'])
        .controller('conditionIsInListCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', conditionIsInListCtrl]);

    function conditionIsInListCtrl($scope, $rootScope, $timeout, canvasService, helpers){
        $scope.displayIsInListConditionOptions = false;
        $scope.displayError = false;
        $scope.descriptionEmpty = false;
        $scope.createListName = {};
        $scope.search = {};

        $rootScope.$on('displayConditionIsInListModal', function(evt, conn, showTip) {
            var entry = document.getElementById(conn.id).getBoundingClientRect();

            $scope.top = entry.top;
            $scope.left = entry.left;
            $scope.entryTop = entry.top;
            $scope.contactListData = $rootScope.contactListData;
            $scope.showTip = showTip;
            $scope.modalPos = $scope.calculateModalPos($scope.top, $scope.left);
            $scope.displayIsInListConditionOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.displayError = false;
            $scope.descriptionEmpty = false;
            $scope.selectedKey = $scope.translate('commons.selectList');

            $timeout(function() {
                $scope.setScrollLogic($scope.connections.id);
            }, 300);

            $scope.sortDataList();

            $(window).resize(function() {
                var entry = document.getElementById($scope.connections.id).getBoundingClientRect();
                $scope.$apply(function()  {
                    $scope.top = entry.top;
                    $scope.left = entry.left;
                    $scope.calculateModalPos($scope.top, $scope.left);
                });
            });
        });

        $rootScope.$on('hideConditionIsInListModal', function() {
            $scope.displayError = false;
            $scope.displayIsInListConditionOptions = false;
        });

        $rootScope.$on('displayConditionIsInListModalError', function() {
            $scope.displayError = true;
        });

        $scope.sortDataList = () => {
            $scope.contactListData = $scope.contactListData.map((i) => {
                if($scope.connections.data.selectedList.indexOf(i.ListId) > -1) {
                    i.selectedItem = true;
                } else {
                    delete i.selectedItem;
                }

                return i;
            });

            Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));
        };

        $scope.createListClick = () => {
            $scope.createList = true;
            $scope.createListName.name = '';
        };

        $scope.goCreateList = () => {
            if($scope.createListName.name) {
                $scope.createListLoader = true;
                canvasService.createContactList($scope.createListName.name)
                    .success(({Results}) => {
                        $scope.createListLoader = false;
                        if(Results.length) {
                            const result = Results[0];
                            const listItem = {
                                ContactCount: 0,
                                ListId: result.ListId,
                                ListName: result.ListName
                            };
                            $scope.contactListData.unshift(listItem);
                            $rootScope.contactListData.unshift(listItem);
                            $scope.toggelListItem(result.ListId, 0);
                            $scope.createList = false;
                            $rootScope.$emit('errorMsg', $scope.translate('common.list.message'), 'confirmation');
                        }
                        else {
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                        }

                    })
                    .error(() => {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                        $scope.createListLoader = false;
                    });
            }
        };

        $scope.goBackList = () => {
            $scope.createList = false;
        };

        $scope.calculateModalPos = function(top, left) {
            var currentTopPercent = ((top/window.innerHeight) * 100);
            var currentLeftPercent = ((left/window.innerWidth) * 100);
            var fixedHeight = 400;
            var fixedwidth = 450;

            if($scope.modalWindow) {
                fixedwidth = 610;
                fixedHeight = 600;
            }

            if((left + 160) > window.innerWidth) {
                currentLeftPercent = 20;
                left = 0;
            }

            var topVal = currentTopPercent + _calculateTopByPos();

            $scope.modalTop = (topVal < 0)? '0%' : (topVal).toFixed(0) + '%';
            $scope.modalLeft = ( currentLeftPercent + _calculateLeftByPos()).toFixed(0) + '%';

            function _calculateTopByPos() {
                var totalTop = top + fixedHeight,
                    resTop = 0;

                if(totalTop > window.innerHeight) {
                    resTop = -38;
                    if($scope.modalWindow) {
                        resTop = -55;
                    }
                }

                return resTop;
            }

            function _calculateLeftByPos() {
                var totalLeft = left + fixedwidth,
                    resLeft = 14;

                if($scope.showTip) {
                    resLeft = 22;
                }

                if(totalLeft > window.innerWidth) {
                    resLeft = -20;
                    if($scope.modalWindow) {
                        resLeft = -25;
                    }
                }



                return resLeft;
            }
        };

        $scope.cancel = function() {
            $scope.displayIsInListConditionOptions = false;

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the is in the list node
                $rootScope.$broadcast('deleteIsInListNode' + $scope.connections.id);
            }
        };

        $scope.save = function() {
            Intercom('trackEvent', 'AP - IsinList');
            $rootScope.$emit('saveConditionIsInListData' + $scope.connections.id, $scope.connections, $scope.descriptionEmpty);
        };

        //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
        $scope.toggelListItem = function (listItem, $i) {
            if($scope.connections.isDummy) {
                $scope.connections.data.selectedList = [];
                delete $scope.connections.isDummy;
            }

            var index = $scope.connections.data.selectedList.indexOf(listItem);
            if (index > -1) {
                $scope.connections.data.selectedList.splice(index, 1);
                delete $scope.contactListData[$i].selectedItem;
            } else {
                $scope.connections.data.selectedList.push(listItem);
                $scope.contactListData[$i].selectedItem = true;
            }

            Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));

            if ($scope.connections.data.selectedList.length) {
                $scope.selectedKey = $scope.translate('commons.editSelection');
            } else {
                $scope.selectedKey = $scope.translate('commons.selectList');
            }
        };

        $scope.displayModal = function(evt) {
            var windowHeight = window.innerHeight * 0.50;
            //Bottom to top
            if (evt.clientY > windowHeight) {
                $(".poc-list").css("top","-270px");
            }else {
                $(".poc-list").css("top","");
            }
            $scope.modalWindow = true;
        };

        $scope.hideModal = function(clearList) {
            if(clearList) {
                $scope.selectedKey = $scope.translate('commons.selectList');
                $scope.connections.data.selectedList = [];
            }
            $scope.modalWindow = false;
            $scope.search.list = "";
            $scope.contactListData = $rootScope.contactListData;
        };

        $scope.parseDescription = function(desc, selected) {
            if (desc && typeof desc === 'object'){
                var descriptionCheck = false;
                for (var item in desc){
                    if(desc[item]) {
                        $scope.descriptionEmpty = false;
                        descriptionCheck = true;
                        //Lists that are currently selected on the node
                        var totalLists = $scope.connections.data.selectedList.length;
                        desc = helpers.getContactListItem(desc[item], $scope.contactListData);

                        //One list selected and > 19
                        if ( totalLists === 1 && desc.length > 19) {
                            desc = desc.slice(0, 19) + '...';
                            //More than one selected
                        } else if (totalLists > 1) {
                            desc = totalLists + $scope.translate('commons.selectedList');
                            //One selected but < 19
                        }  else if (totalLists === 1 && desc.length < 19) {
                            desc = desc;
                        }
                        break;
                    }
                }
                if(!descriptionCheck) {
                    $scope.descriptionEmpty = true;

                    if (selected === 'showSelectedList') {
                        return '';
                    } else {
                        return $scope.translate('commons.enterDetails');
                    }
                }

            } else {
                $scope.descriptionEmpty = true;

                if (selected === 'showSelectedList') {
                    return '';
                } else {
                    return $scope.translate('commons.enterDetails');
                }
            }

            return desc;
        };

        $scope.setScrollLogic = function(id) {
            $scope.listLoader = false;
            angular.element(
                document.getElementById('contactListContainer' + id)).bind("scroll",
                function () {
                    if(!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                        $scope.listLoader = true;
                        canvasService.getContactList($rootScope.contactListOffset, 10)
                            .success(function(data) {
                                if(!data.Results.length) {
                                    $rootScope.stopLoadingList = true;
                                }
                                else {
                                    $rootScope.contactListOffset++;
                                    $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(data.Results), 'ListId');
                                    $scope.contactListData = $rootScope.contactListData;
                                    Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));
                                }
                                $scope.listLoader = false;
                            })
                            .error(function() {
                                $scope.listLoader = false;
                            })
                    }
                }
            );
        };

        $scope.searching = false;
        $scope.search.search =  (val) => {
            if(val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactList(val)
                    .then((res) => {
                        $scope.searching = false;
                        $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(res.data.Results), 'ListId');
                        $scope.contactListData = [];
                        $scope.contactListData = $scope.contactListData.concat(res.data.Results);
                        $scope.sortDataList();
                    })
                    .catch(() => {
                        $scope.searching = false;
                    });
            } else {
                $scope.contactListData = $rootScope.contactListData;
                $scope.sortDataList();
            }
        };
    };
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/conditionIsInListController.js